import React from 'react';
import { FadeIn } from './FadeIn';
export function BonusSection() {
  const bonuses = [{
    title: '100 Citas Padre e Hija',
    value: '$10.000'
  }, {
    title: '100 Citas Juntos (Pareja)',
    value: '$15.000'
  }, {
    title: '25 Citas con mis Peluditos (Mascotas)',
    value: '$5.000'
  }];
  return <section className="py-10 bg-slate-900 text-white relative overflow-hidden" data-id="element-27" data-mp="1ydryi2ce0at3">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-brand-500/10 rounded-full blur-3xl" data-id="element-28" data-mp="1ap8rdq52q42l"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-500/10 rounded-full blur-3xl" data-id="element-29" data-mp="15qnlpb71ys6r"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-30" data-mp="1jibyzht1fmpb">
        <FadeIn data-id="element-31" data-mp="1epivex9b2ket">
          <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-32" data-mp="1eozmu75jp8dg">
            <div className="inline-block bg-brand-500 text-white font-bold px-4 py-1 rounded-full text-sm mb-3 animate-pulse" data-id="element-33" data-mp="r0ge5qil2tku">
              SOLO POR HOY
            </div>
            <h2 className="text-2xl md:text-4xl font-bold mb-3" data-id="element-34" data-mp="mws6z8xv6004">
              BONOS EXCLUSIVOS
            </h2>
            <p className="text-lg text-slate-300" data-id="element-35" data-mp="29q8q4on9f5ip">
              Llevate todo este contenido adicional completamente gratis con tu
              compra de hoy.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-36" data-mp="2ogzibxsrk6mc">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-37" data-mp="1qth2y44lk69d" data-mpi={index}>
              <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 p-6 rounded-2xl flex items-center gap-4 hover:bg-slate-800 transition-colors" data-id="element-38" data-mp="1qv1v5n3fvd42">
                <div className="text-4xl bg-slate-700 w-16 h-16 rounded-xl flex items-center justify-center shrink-0" data-id="element-39" data-mp="20qdbg9uhwsdx">
                  🎁
                </div>
                <div data-id="element-40" data-mp="3c6k22iwqr7wo">
                  <h3 className="font-bold text-lg md:text-xl mb-1" data-id="element-41" data-mp="3c73ddgrvyy1q">
                    {bonus.title}
                  </h3>
                  <div className="flex items-center gap-2 text-sm md:text-base" data-id="element-42" data-mp="3h4bt7apkapzt">
                    <span className="text-slate-400 line-through" data-id="element-43" data-mp="1h2lzkzcmp3ss">
                      Valorado en {bonus.value}
                    </span>
                    <span className="text-brand-400 font-bold" data-id="element-44" data-mp="1c6eut9vyxycf">→ ¡GRATIS!</span>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}